import { combineReducers } from 'redux';
import info from './info'
import address from './address'
import etc from './etc'

import * as ActionTypes from '../../../constants/setting/blog'


const initialized = (state = false, action) => {
	switch(action.type) {
		case ActionTypes.RECEIVE_SETTINGS:
			return true

		default:
			return state
	}
}

export default combineReducers({
	info,
	address,
	etc,
	initialized
})
